import { Store, iNotification } from "react-notifications-component";

export const openNotification = (
  notification: Pick<iNotification, "message" | "type">,
  additionalConfig?: iNotification
) => {
  Store.addNotification({
    ...notification,
    ...additionalConfig,
    insert: "top",
    container: "top-right",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 3000,
      onScreen: true,
    },
  });
};
